import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Badge, Button } from 'reactstrap';
import { MoonLoader } from 'react-spinners';
import _ from 'lodash';
import axios from 'axios';

import { getFirebaseBackend } from 'helpers/firebaseHelper';
import { CardInputGoogleDriveStyled } from './styles';
import TextInput from 'components/Text-Input';
import LabelGroup from 'components/Label-Group';
import { GDriveIcon } from 'assets/icons';
import { servicesFolder } from '../../../../constants';

const CardInputGoogleDrive = ({ accountId, accountName, service, label, folderLink, disabled }) => {
  const { t: translate } = useTranslation();
  const firebaseHelper = getFirebaseBackend();

  const [isSaved, setIsSaved] = useState(false);
  const [isCreatingFolder, setIsCreatingFolder] = useState(false);
  const [gDriveFolder, setGDriveFolder] = useState(folderLink);

  const color = servicesFolder.find((s) => s.value === service)?.color;

  const handleCreateNewFolder = async () => {
    setIsCreatingFolder(true);

    try {
      const { data } = await axios.post(
        process.env.REACT_APP_GDOCS_WEBHOOK_CREATE_FOLDER,
        {
          accountName,
          folders: [service],
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_GDOCS_FLOW_KEY}`,
          },
        },
      );

      const folderUrl = data?.[service]?.root;

      if (folderUrl) {
        setGDriveFolder(folderUrl);
        await firebaseHelper.saveGDriveFolderLink(accountId, data);
        setIsSaved(true);
      }
    } catch (error) {
      setIsSaved(false);
      console.log('Error creating new folder:', error);
    } finally {
      setIsCreatingFolder(false);
    }
  };

  const openInputLink = () => {
    window.open(gDriveFolder, '_blank');
  };

  useEffect(() => {
    if (folderLink) {
      setGDriveFolder(folderLink);
    }
  }, [folderLink]);

  return (
    <CardInputGoogleDriveStyled>
      <LabelGroup htmlFor="gDriveFolder" label="" mb={0} column>
        <div className="d-flex gap-2 align-items-center mb-2">
          <GDriveIcon width="2rem" height="2rem" />
          {translate('File directory')}
          <Badge style={{ background: color }} color={color}>
            {label}
          </Badge>
        </div>
        {gDriveFolder && (
          <div className="d-flex gap-1">
            <div>
              <TextInput
                id="gDriveFolder"
                controlName="gDriveFolder"
                value={gDriveFolder}
                disabled={disabled}
                noEllipsis
              />
            </div>
            <Button
              className="btn-go-to open-link-button"
              onClick={openInputLink}
              disabled={disabled}
            >
              <i className="bx bx-link-external" />
            </Button>
          </div>
        )}
      </LabelGroup>

      {!isSaved && !gDriveFolder && (
        <div className="d-flex gap-2">
          <Button
            className="btn-new-folder"
            onClick={handleCreateNewFolder}
            disabled={isCreatingFolder || disabled}
          >
            {isCreatingFolder ? (
              <MoonLoader size={20} color="#000" />
            ) : (
              <>
                <i className="bx bx-plus" />
                {translate('Create new folder')}
              </>
            )}
          </Button>
        </div>
      )}
    </CardInputGoogleDriveStyled>
  );
};

CardInputGoogleDrive.propTypes = {
  accountId: PropTypes.string,
  accountName: PropTypes.string,
  service: PropTypes.string,
  label: PropTypes.string,
  folderLink: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CardInputGoogleDrive;
